<template>
  <b-container fluid="xl" style="max-width:1400px">
    <SiteHeader />
    <b-row class="align-items-start">
      <transition name="fade" appear>
        <b-col tag="main" cols="12" lg="12" class="bg-white p-0">
          <div class="overflow-hidden p-4 p-sm-0 mt-4">
            <slot />
          </div>
        </b-col>
      </transition>
    </b-row>
    <SiteFooter />
  </b-container>
</template>

<script>
import SiteHeader from '../components/SiteHeader.vue'
import SiteFooter from '../components/SiteFooter'
export default {
  components: {
    SiteHeader,
SiteFooter

  }
}
</script>

<style>
.fade-enter-active {
  transition: 0.5s;
}

.fade-enter {
  opacity: 0;
}
</style>
